import React from "react";
import { Check, X, Minus } from "lucide-react";
import { useReveal } from "@/hooks/useReveal";

const comparisonData = [
  {
    feature: "Active STR investor on team",
    typical: false,
    jnnhomes: true,
  },
  {
    feature: "Owns and operates own STRs",
    typical: false,
    jnnhomes: true,
  },
  {
    feature: "AI-powered 24/7 guest response",
    typical: false,
    jnnhomes: true,
  },
  {
    feature: "County-specific compliance handling",
    typical: "Sometimes",
    jnnhomes: "Always",
  },

  {
    feature: "Acquisition + financing support",
    typical: false,
    jnnhomes: true,
  },
  {
    feature: "Bilingual support",
    typical: false,
    jnnhomes: true,
  },
];

export default function CoHostComparison() {
  const revealRef = useReveal<HTMLDivElement>();
  return (
    <section className="py-24 bg-muted/30 relative">
      <div ref={revealRef} className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16 space-y-4 reveal reveal-delay-1">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground">
            JNN Homes vs.{" "}
            <span className="text-muted-foreground">Typical Co-Hosts</span>
          </h2>
          <p className="text-lg text-muted-foreground">
            See why leading investors and homeowners choose our comprehensive
            management approach over standard co-hosting services.
          </p>
        </div>

        <div className="reveal reveal-delay-2 max-w-4xl mx-auto bg-card border border-border rounded-2xl overflow-hidden shadow-lg">
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="bg-muted/50 border-b border-border">
                  <th className="p-4 md:p-6 text-sm md:text-base font-bold text-foreground w-1/2">
                    Features & Support
                  </th>
                  <th className="p-4 md:p-6 text-sm md:text-base font-bold text-muted-foreground text-center w-1/4">
                    Typical Northern Virginia Co-Host
                  </th>
                  <th className="p-4 md:p-6 text-sm md:text-base font-bold text-primary text-center w-1/4 bg-primary/5">
                    JNN Homes
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border">
                {comparisonData.map((row, index) => (
                  <tr
                    key={index}
                    className="transition-colors hover:bg-muted/20"
                  >
                    <td className="p-4 md:p-6 text-sm md:text-base font-medium text-foreground">
                      {row.feature}
                    </td>
                    <td className="p-4 md:p-6 text-center">
                      {typeof row.typical === "boolean" ? (
                        row.typical ? (
                          <Check className="w-5 h-5 text-primary mx-auto" />
                        ) : (
                          <X className="w-5 h-5 text-destructive mx-auto" />
                        )
                      ) : (
                        <span className="text-sm font-medium text-muted-foreground">
                          {row.typical}
                        </span>
                      )}
                    </td>
                    <td className="p-4 md:p-6 text-center bg-primary/5">
                      {typeof row.jnnhomes === "boolean" ? (
                        row.jnnhomes ? (
                          <div className="flex justify-center items-center gap-2">
                            <Check className="w-5 h-5 text-primary" />
                          </div>
                        ) : (
                          <X className="w-5 h-5 text-destructive mx-auto" />
                        )
                      ) : (
                        <div className="flex justify-center items-center gap-1.5">
                          <Check className="w-5 h-5 text-primary" />
                          <span className="text-sm font-bold text-primary">
                            {row.jnnhomes}
                          </span>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}
